import { User } from "../../interfaces/User";
import { Meeting, SimpleMeeting } from "../../interfaces/Meeting";
import { getSubString, isEmail, isFileUrl, isValidUrl } from "../general";
import { isImageUrl } from "../general";
import { SimplePipeline } from "../../interfaces/Pipeline";
import { IntlShape } from "react-intl";
import { CustomField, SettingMultiMeetings, SettingMultiMerchants, SettingMultiPipelines } from "../../interfaces/Settings";
import { SimpleMerchant } from "../../interfaces/Merchant";
import moment from "moment-timezone";
import { UserModel } from "../../app/modules/auth/models/UserModel";
import { getColumnExcelNameLetter, getColumnIndexFromLetter } from "./helperTemplateExcel";
import { SimpleProduct } from "../../interfaces/Product";

export const getLastUuid = (str: Meeting | SimpleMeeting) => {
    const splitData = str?.id?.split('-');
    const subString = splitData?.[splitData.length - 1].substring(7, splitData?.[splitData.length - 1].length);
    return subString
}

export const getCustomFieldFilteredMeeting = (templateMeetingId: string, multiMeetings: SettingMultiMeetings[]) => {
    let arrayCustomFieldMeeting: CustomField = templateMeetingId && multiMeetings.length > 0 ? multiMeetings.find(item => item.id === templateMeetingId)?.customFields as CustomField : {};
    let filteredCustomFieldMeeting = Object.fromEntries(
        Object.entries(arrayCustomFieldMeeting as CustomField).filter(([key, value]) => {
            return value && typeof value === 'object' && value.type !== 'serial'
        })
    );
    return filteredCustomFieldMeeting
}

export const getCustomFieldFilteredMerchant = (templateMerchantId: string, multiMerchants: SettingMultiMerchants[], user: UserModel) => {
    let arrayCustomFieldMerchant: CustomField = templateMerchantId && multiMerchants.length > 0 ? multiMerchants.find(item => item.id === templateMerchantId)?.customFields as CustomField : {};
    let filteredCustomFieldMerchant = Object.fromEntries(
        Object.entries(arrayCustomFieldMerchant as CustomField).filter(([key, value]) => {
            if (key === '604fa678-e655-4426-918d-aa5fa75d2325') return false
            return value && typeof value === 'object' && value.type !== 'serial'
        })
    );
    return filteredCustomFieldMerchant
}

export const getCustomFieldFilteredUser = (customFields: CustomField) => {
    let filteredCustomFieldUsers = Object.fromEntries(
        Object.entries(customFields).filter(([key, value]) => {
            return value && typeof value === 'object' && value.type !== 'serial'
        })
    );
    return filteredCustomFieldUsers
}

export const getCustomFieldFilteredPipeline = (templatePipelineId: string, multiPipelines: SettingMultiPipelines[], user: UserModel) => {
    let arrayCustomFieldPipeline: CustomField = templatePipelineId && multiPipelines.length > 0 ? multiPipelines.find(item => item.id === templatePipelineId)?.customFields! : {};
    let filteredCustomFieldPipeline = Object.fromEntries(
        Object.entries(arrayCustomFieldPipeline as CustomField).filter(([key, value]) => {
            return value && typeof value === 'object' && value.type !== 'serial'
        })
    );
    return filteredCustomFieldPipeline
}

export const getCustomFieldError = (data: any, dataCustomField: CustomField, key: string, customFieldErrors: string[], intl: IntlShape, simplePipelines: SimplePipeline[], simpleMeetings: SimpleMeeting[], simpleMerchants: SimpleMerchant[], simpleProducts: SimpleProduct[], users: User[], user: UserModel) => {
    const field = dataCustomField[key];
    const fieldType = dataCustomField[key].type;
    const value = data[key];

    if (field.required && !value && fieldType !== 'serial') {
        customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: field.name }));
    } else if (value) {
        if (fieldType === 'image') {
            if (!isImageUrl(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.URL_CORRECTLY' }, { title: field.name }));
            }
        } if (fieldType === 'file') {
            if (!isFileUrl(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.URL_CORRECTLY' }, { title: field.name }));
            }
        } if (fieldType === 'date') {
            if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_FORMAT_CORRECTLY' }, { title: field.name }));
            }
        } if (fieldType === 'dateTime') {
            if (!moment(value, 'YYYY-MM-DD HH:mm', true).isValid()) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_FORMAT_CORRECTLY' }, { title: field.name }));
            }
        } if (fieldType === 'email') {
            if (!isEmail(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.EMAIL' }));
            }
        } if (fieldType === 'link') {
            if (!isValidUrl(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.LINK_FORMAT_CORRECTLY' }));
            }
        } if (fieldType === 'dateTimeRange') {
            if (!value && field.required) {
                customFieldErrors.push(intl.formatMessage(
                    { id: 'FORM.VALIDATION.FIELD_REQUIRED' },
                    { title: field.name }
                ));
            } else {
                const dateTimeRangeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2} - \d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
                if (!dateTimeRangeRegex.test(value)) {
                    customFieldErrors.push(intl.formatMessage(
                        { id: 'FORM.VALIDATION.DATE_TIME_RANGE_FORMAT' },
                        {
                            title: field.name,
                            format: "YYYY-MM-DD HH:mm - YYYY-MM-DD HH:mm"
                        }
                    ));
                } else {
                    const [startDateTime, endDateTime] = value.split(' - ');

                    if (!startDateTime || !endDateTime) {
                        customFieldErrors.push(intl.formatMessage(
                            { id: 'FORM.VALIDATION.DATE_TIME_RANGE_REQUIRED' },
                            { title: field.name }
                        ));
                    } else if (!moment(startDateTime, 'YYYY-MM-DD HH:mm').isValid() ||
                        !moment(endDateTime, 'YYYY-MM-DD HH:mm').isValid()) {
                        customFieldErrors.push(intl.formatMessage(
                            { id: 'FORM.VALIDATION.INVALID_DATE_TIME_RANGE' },
                            { title: field.name }
                        ));
                    } else if (moment(endDateTime).isSameOrBefore(startDateTime)) {
                        customFieldErrors.push(intl.formatMessage(
                            { id: 'FORM.VALIDATION.END_DATE_TIME_BEFORE_START' },
                            { title: field.name }
                        ));
                    }
                }
            }
        } if (fieldType === 'time') {
            if (!value && field.required) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: field.name }));
            } else if (value) {
                const timeRegex = /^\d{2}:\d{2}$/;
                if (!timeRegex.test(value)) {
                    customFieldErrors.push(intl.formatMessage(
                        { id: 'FORM.VALIDATION.TIME_FORMAT_CORRECTLY' },
                        { title: field.name }
                    ));
                } else {
                    const [hours, minutes] = value.split(':').map(Number);

                    if (hours < 0 || hours > 23) {
                        customFieldErrors.push(intl.formatMessage(
                            { id: 'FORM.VALIDATION.INVALID_HOURS' },
                            { title: field.name }
                        ));
                    }

                    if (minutes < 0 || minutes > 59) {
                        customFieldErrors.push(intl.formatMessage(
                            { id: 'FORM.VALIDATION.INVALID_MINUTES' },
                            { title: field.name }
                        ));
                    }
                }
            }
        } if (fieldType === 'number') {
            if (isNaN(Number(value))) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.INVALID_NUMBER' }, { title: field.name }));
            }
        } if (fieldType === 'pipeline') {
            const getSameValueBySimplePipeline = (value: string) => {
                const inputPipelineValues = value
                const simplePipelineStrings = simplePipelines.map((item: SimplePipeline) => {
                    return item.name + " / " + item.nominal + " / " + moment(item.dateCreated).format('DD MMM YYYY')
                });
                const hasMatch = simplePipelineStrings.includes(inputPipelineValues)
                return hasMatch;
            }
            if (!getSameValueBySimplePipeline(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
            }
        } if (fieldType === 'meeting') {
            const getSameValueBySimpleMeeting = (value: string) => {
                const getValueMultiple = value.split(',').map((item: string) => item.trim())
                const simpleMeeting = simpleMeetings.map((item: SimpleMeeting) => {
                    return item.name + " / " + moment(item.dateMeet).format('DD MMM YYYY') + " / " + item.meetingStatus + " / " + getLastUuid(item)
                })
                const isSameValue = getValueMultiple.find((item: string) => simpleMeeting.includes(item))
                return isSameValue
            }
            if (!getSameValueBySimpleMeeting(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
            }
        } if (fieldType === 'merchant') {
            const getSameValueBySimpleMerchant = (value: string) => {
                const getValueMultiple = value.split(',').map((item: string) => item.split(' / ')[0].trim())
                const simpleMerchant = simpleMerchants.map((item: SimpleMerchant) => {
                    return item.name
                })
                const isSameValue = getValueMultiple.find((item: string) => simpleMerchant.includes(item))
                return isSameValue
            }
            if (!getSameValueBySimpleMerchant(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
            }
        } if (fieldType === 'user') {
            const getSameValueBySimpleUser = (value: string) => {
                const getValueMultiple = value.split(',').map((item: string) => item.trim());
                const simpleUser = users.map((item: User) => item.name);
                const allValuesExist = getValueMultiple.every((inputValue: string) => simpleUser.includes(inputValue));
                return allValuesExist;
            };
            if (!getSameValueBySimpleUser(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
            }
        } if (fieldType === 'multiple' || fieldType === 'multipleOption') {
            const getValueMultiple = value.split(',').map((item: string) => item.trim())
            if (getValueMultiple.length > 0) {
                const valueMultiple = dataCustomField[key].value

                if (Array.isArray(valueMultiple)) {
                    const allValuesExist = getValueMultiple.every((inputValue: string) =>
                        (valueMultiple as string[]).includes(inputValue as string)
                    );

                    if (!allValuesExist) {
                        customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
                    }
                } else {
                    customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
                }
            }
        } if (fieldType === 'files') {
            const getValueMultiple = value && typeof value === 'object' ? (value.text as string).split(',').map((item: string) => item.trim()) : []
            if (getValueMultiple.length > 0) {
                const valueMultiple = dataCustomField[key].value
                if (Array.isArray(valueMultiple)) {
                    const allValuesExist = getValueMultiple.every((inputValue: string) => {
                        const isValidFiles = isFileUrl(inputValue)
                        return isValidFiles
                    });
                    if (!allValuesExist) {
                        customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.URL_CORRECTLY' }, { title: field.name }));
                    }
                }
            }
        } if (fieldType === 'images') {
            const getValueMultiple = value && typeof value === 'object' ? (value.text as string).split(',').map((item: string) => item.trim()) : []
            if (getValueMultiple.length > 0) {
                const valueMultiple = dataCustomField[key].value
                if (Array.isArray(valueMultiple)) {
                    const allValuesExist = getValueMultiple.every((inputValue: string) => {
                        const isValidFiles = isImageUrl(inputValue)
                        return isValidFiles
                    });
                    if (!allValuesExist) {
                        customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.URL_CORRECTLY' }, { title: field.name }));
                    }
                }
            }
        } if (fieldType === 'product') {
            const getSameValueBySimpleProduct = (value: string) => {
                const getValueMultiple = value.split(',').map((item: string) => item.trim())
                const simpleProduct = simpleProducts.map((item: SimpleProduct) => {
                    return item.name
                })
                const isSameValue = getValueMultiple.find((item: string) => simpleProduct.includes(item))
                return isSameValue
            }
            if (!getSameValueBySimpleProduct(value)) {
                customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.IS_NOT_MATCHING' }, { title: field.name }));
            }
        }
    }
}

export const getCellNote = (sheet: string) => {
    return {
        texts: [{
            text: `Untuk memilih beberapa nilai:\n1. Pilih satu nilai dari Sheet ${sheet}\n2. Tambahkan koma (,) setelah nilai tersebut\nContoh: Value1, Value2, Value3`,
        }]
    }
}

export const getCellNoteLocation = () => {
    return {
        texts: [{
            text: `Silahkan pilih lokasi anda di google maps, \nkemudian copy link alamat url yang di atas\nContoh: https://www.google.com/maps/place/Jl.+Satelite+Utara+IX+No.JT+29,+Tanjungsari,+Kec.+Sukomanunggal,+Surabaya,+Jawa+Timur+60154/@-7.263704,112.692808,19z/`,
        }]
    }
}

export const getCustomFieldsValues = (data: any, customFields: CustomField, simplePipelines: SimplePipeline[], simpleMerchants: SimpleMerchant[], simpleMeetings: SimpleMeeting[], simpleProducts: SimpleProduct[], users: User[], user: UserModel) => {
    const customFieldsValues: { [key: string]: string | string[] | null } = {};
    Object.keys(customFields).forEach((key) => {
        const type = customFields[key].type
        if (type === 'dateTimeRange') {
            if (data[key]) {
                const [startDate, endDate] = data[key].split(' - ');
                customFieldsValues[key] = [
                    startDate ? (new Date(startDate).toISOString() as any) : null,
                    endDate ? (new Date(endDate).toISOString() as any) : null
                ];
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'time') {
            if (data[key]) {
                const [hours, minutes] = data[key].split(':').map(Number);
                const today = new Date();
                today.setHours(hours, minutes, 0, 0);
                customFieldsValues[key] = today.toISOString();
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'dateTime') {
            if (data[key]) {
                customFieldsValues[key] = moment(data[key]).toISOString();
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'pipeline') {
            const pipelineValue = data[key] ? data[key] : null
            if (pipelineValue && Array.isArray(simplePipelines) && simplePipelines.length > 0) {
                try {
                    const pipelineStrings = simplePipelines.map((pipeline: any) => {
                        return {
                            id: pipeline.id,
                            formattedString: pipeline.name + " / " +
                                pipeline.nominal +
                                " / " + moment(pipeline.dateCreated).format("DD MMM YYYY")
                        };
                    });

                    const matchedPipeline = pipelineStrings.find(p =>
                        p.formattedString === pipelineValue
                    );

                    customFieldsValues[key] = matchedPipeline ? matchedPipeline.id : null;
                } catch (error) {
                    console.error('Error matching pipeline:', error);
                    customFieldsValues[key] = null;
                }
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'merchant') {
            const merchantValue = data[key] ? data[key].split(',').map((item: string) => item.split(' / ')[0].trim()) : null
            if (Array.isArray(merchantValue) && Array.isArray(simpleMerchants) && simpleMerchants.length > 0 && merchantValue.length > 0) {
                try {
                    const merchantArray = simpleMerchants.filter((merchant: any) => merchantValue.includes(merchant.name))
                    customFieldsValues[key] = merchantArray.map((merchant: any) => merchant.id)
                } catch (error) {
                    console.error('Error matching merchant:', error);
                    customFieldsValues[key] = null;
                }
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'meeting') {
            const meetingValue = data[key] ? data[key].split(',').map((item: string) => item.trim()) : null;
            if (
                Array.isArray(meetingValue) &&
                Array.isArray(simpleMeetings) &&
                simpleMeetings.length > 0 &&
                meetingValue.length > 0
            ) {
                try {

                    const meetingStrings = simpleMeetings.map((meeting: any) => ({
                        id: meeting.id,
                        formattedString: `${meeting.name} / ${moment(meeting.dateMeet).format('DD MMM YYYY')} / ${meeting.meetingStatus} / ${meeting.id.split('-')[meeting.id.split('-').length - 1].substring(7)}`,
                    }));

                    const matchedMeeting = meetingStrings.filter((string) => {
                        return meetingValue.includes(string.formattedString);
                    })
                    customFieldsValues[key] = matchedMeeting ? matchedMeeting.map((meeting: any) => meeting.id) : null;
                } catch (error) {
                    console.error('Error matching meeting:', error);
                    customFieldsValues[key] = null;
                }
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'user') {
            const userValue = data[key] ? data[key].split(',').map((item: string) => item.trim()) : null
            if (Array.isArray(userValue) && Array.isArray(users) && users.length > 0 && userValue.length > 0) {
                const userArray = users.filter((user: any) => userValue.includes(user.name))
                customFieldsValues[key] = userArray.map((user: any) => user.id)
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'multiple' || type === 'multipleOption') {
            const getValueMultiple = data[key] ? data[key].split(',').map((item: string) => item.trim()) : null
            if (Array.isArray(getValueMultiple) && getValueMultiple.length > 0) {
                customFieldsValues[key] = getValueMultiple;
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'files' || type === 'images' || type === 'videos') {
            const getValueMultiple = data[key] && typeof data[key] === 'object' ? (data[key].text as string).split(',').map((item: string) => item.trim()) : data[key] ? data[key].split(',').map((item: string) => item.trim()) : null
            if (Array.isArray(getValueMultiple) && getValueMultiple.length > 0) {
                customFieldsValues[key] = getValueMultiple;
            } else {
                customFieldsValues[key] = null;
            }
        } else if (type === 'product') {
            const productValue = data[key] ? data[key].split(',').map((item: string) => item.trim()) : null
            if (Array.isArray(productValue) && Array.isArray(simpleProducts) && simpleProducts.length > 0 && productValue.length > 0) {
                try {
                    const productArray = simpleProducts.filter((product: any) => productValue.includes(product.name))
                    customFieldsValues[key] = productArray.map((product: any) => product.id)
                } catch (error) {
                    console.error('Error matching product:', error);
                    customFieldsValues[key] = null;
                }
            } else {
                customFieldsValues[key] = null;
            }
        } else {
            customFieldsValues[key] = data[key] || null;
        }
    });
    return customFieldsValues
}

export const addSingleOptionValidation = (startColumn: string, customFields: any, singleOptionSheets: any, typeAction: string, type: string, param: any, worksheet: any, simpleCustomFieldsMaster: any) => {
    let currentColumn = getColumnIndexFromLetter(startColumn)
    Object.entries(customFields).forEach(([key, field]: [string, any]) => {
        if (field.type === 'option') {
            const { columnLetter, worksheetName, dataLength } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            for (let i = 3; i <= (typeAction === 'update' ? dataLength + 2 : 1000); i++) {
                worksheet.getCell(`${columnLetter}${i}`).dataValidation = {
                    type: 'list',
                    allowBlank: true,
                    showErrorMessage: true,
                    formulae: [`='${worksheetName}'!$A$2:$A$${field.value.length + 1}`],
                    errorStyle: 'error',
                    error: `Pilih ${field.name}`,
                };
            }
        } else if (field.type === 'pipeline') {
            const { columnLetter, worksheetName, dataLength } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            const pipelineList = simpleCustomFieldsMaster?.pipelines?.[key] || [];
            const dataLen = pipelineList.length;
            for (let i = 3; i <= (typeAction === 'update' ? dataLength + 2 : 1000); i++) {
                worksheet.getCell(`${columnLetter}${i}`).dataValidation = {
                    type: 'list',
                    allowBlank: true,
                    showErrorMessage: true,
                    formulae: [`='${worksheetName}'!$A$2:$A$${dataLen + 1}`],
                    errorStyle: 'error',
                    error: `Pilih ${field.name}`,
                };
            }
        } else if (field.type === 'meeting') {
            const { columnLetter, worksheetName } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            for (let i = 3; i <= 3; i++) {
                const cell = worksheet.getCell(`${columnLetter}${i}`);
                cell.note = getCellNote(worksheetName);
            }
        } else if (field.type === 'merchant') {
            const { columnLetter, worksheetName } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            for (let i = 3; i <= 3; i++) {
                const cell = worksheet.getCell(`${columnLetter}${i}`);
                cell.note = getCellNote(worksheetName);
            }
        } else if (field.type === 'user') {
            const { columnLetter, worksheetName } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            for (let i = 3; i <= 3; i++) {
                const cell = worksheet.getCell(`${columnLetter}${i}`);
                cell.note = getCellNote(worksheetName);
            }
        } else if (field.type === 'multiple' || field.type === 'multipleOption') {
            const { columnLetter, worksheetName } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            for (let i = 3; i <= 3; i++) {
                const cell = worksheet.getCell(`${columnLetter}${i}`);
                cell.note = getCellNote(worksheetName);
            }
        } else if (field.type === 'product') {
            const { columnLetter, worksheetName } = getColumnExcelNameLetter(currentColumn, key, typeAction, type, param, singleOptionSheets);
            for (let i = 3; i <= 3; i++) {
                const cell = worksheet.getCell(`${columnLetter}${i}`);
                cell.note = getCellNote(worksheetName);
            }
        }
        currentColumn++;
    });
};

export const validateLabel = (data: any, labels: any[], intl: IntlShape): string[] => {
    const errors: string[] = [];

    if (data.label_name && data.label_name.trim() !== '') {
        const labelNames = data.label_name.split(',').map((name: string) => name.trim());
        const invalidLabels: string[] = [];

        labelNames.forEach((labelName: string) => {
            const foundLabel = labels.find((label: any) =>
                label.name.toLowerCase() === labelName.toLowerCase()
            );
            if (!foundLabel) {
                invalidLabels.push(labelName);
            }
        });

        if (invalidLabels.length > 0) {
            errors.push(
                intl.formatMessage(
                    { id: 'FORM.VALIDATION.LABEL_NOT_FOUND' },
                    { title: invalidLabels.join(', ') }
                )
            );
        }
    }

    return errors;
};

export const validateMeetingParticipants = (data: any, usersCompany: any[], intl: IntlShape): string[] => {
    const errors: string[] = [];

    if (data.usersName && data.usersName.trim() !== '') {
        const participantNames = data.usersName.split(',').map((name: string) => name.trim());
        const invalidParticipants: string[] = [];
        participantNames.forEach((participantName: string) => {
            const foundParticipant = usersCompany.find((user: any) =>
                user.ownerName.trim().toLowerCase() === participantName.trim().toLowerCase()
            );

            if (!foundParticipant) {
                invalidParticipants.push(participantName);
            }
        });

        if (invalidParticipants.length > 0) {
            errors.push(
                intl.formatMessage(
                    { id: 'FORM.VALIDATION.PARTICIPANT_NOT_FOUND' },
                    { title: invalidParticipants.join(', ') }
                )
            );
        }
    }

    return errors;
};

export const getLabelValuesCustomFields = (row: any, customFields: CustomField, simplePipelines: SimplePipeline[], simpleMerchants: SimpleMerchant[], simpleMeetings: SimpleMeeting[], simpleProducts: SimpleProduct[], users: User[]) => {
    if (!customFields || Object.keys(customFields).length === 0) {
        return [];
    }

    if (!row || !row.customFields) {
        return Object.keys(customFields).map(() => '');
    }

    return Object.keys(customFields).map((field: any) => {
        if (!customFields[field]) {
            return '';
        }

        if (row.customFields?.hasOwnProperty(field)) {
            const fieldValue = row.customFields[field];

            if (fieldValue === null || fieldValue === undefined) {
                return '';
            }

            if (customFields[field].type === 'pipeline') {
                if (!simplePipelines || simplePipelines.length === 0) {
                    return '';
                }
                const getLabelPipelines = simplePipelines.find(item => item.id === fieldValue);
                return getLabelPipelines
                    ? `${getLabelPipelines.name || '-'} / ${getLabelPipelines.nominal || '-'} / ${getLabelPipelines.dateCreated ? moment(getLabelPipelines.dateCreated).format("DD MMM YYYY") : '-'}`
                    : '';
            } else if (customFields[field].type === 'merchant') {
                if (!Array.isArray(fieldValue) || fieldValue.length === 0 || !simpleMerchants || simpleMerchants.length === 0) {
                    return '';
                }
                const getMultiLabelMerchants = simpleMerchants.filter(item => fieldValue.includes(item.id));
                return getMultiLabelMerchants.length > 0
                    ? getMultiLabelMerchants.map(item => `${item.name || '-'} / ${item.phone || '-'}`).join(', ')
                    : '';
            } else if (customFields[field].type === 'meeting') {
                if (!Array.isArray(fieldValue) || fieldValue.length === 0 || !simpleMeetings || simpleMeetings.length === 0) {
                    return '';
                }
                const getMultiLabelMeetings = simpleMeetings.filter(item => fieldValue.includes(item.id));
                return getMultiLabelMeetings.length > 0
                    ? getMultiLabelMeetings.map(item => `${item.name || '-'} / ${item.dateMeet ? moment(item.dateMeet).format("DD MMM YYYY") : '-'} / ${item.meetingStatus || '-'} / ${getSubString(item.id) || '-'}`).join(', ')
                    : '';
            } else if (customFields[field].type === 'product') {
                if (!Array.isArray(fieldValue) || fieldValue.length === 0 || !simpleProducts || simpleProducts.length === 0) {
                    return '';
                }
                const getMultiLabelProducts = simpleProducts.filter(item => fieldValue.includes(item.id));
                return getMultiLabelProducts.length > 0
                    ? getMultiLabelProducts.map(item => `${item.name || '-'}`).join(', ')
                    : '';
            } else if (customFields[field].type === 'user') {
                if (!Array.isArray(fieldValue) || fieldValue.length === 0 || !users || users.length === 0) {
                    return '';
                }
                const getMultiLabelUsers = users.filter(item => fieldValue.includes(item.id));
                return getMultiLabelUsers.length > 0
                    ? getMultiLabelUsers.map(item => `${item.name || '-'}`).join(', ')
                    : '';
            } else if (customFields[field].type === 'images' || customFields[field].type === 'files' || customFields[field].type === 'multiple' || customFields[field].type === 'multipleOption') {
                if (Array.isArray(fieldValue)) {
                    if (fieldValue.length === 0) {
                        return '';
                    } else if (fieldValue.length === 1) {
                        return fieldValue[0] || '';
                    } else {
                        return fieldValue.filter(val => val !== null && val !== undefined).join(', ') || '';
                    }
                } else if (typeof fieldValue === 'string' || typeof fieldValue === 'number') {
                    return fieldValue.toString();
                }
                return '';
            } else if (customFields[field].type === 'dateTimeRange') {
                if (!Array.isArray(fieldValue) || fieldValue.length < 2) {
                    return '';
                }
                try {
                    return fieldValue
                        .filter(item => item !== null && item !== undefined)
                        .map((item: any) => moment(item).format('YYYY-MM-DD HH:mm'))
                        .join(' - ') || '';
                } catch (error) {
                    return '';
                }
            } else if (customFields[field].type === 'dateTime') {
                try {
                    return fieldValue ? moment(fieldValue).format('YYYY-MM-DD HH:mm') : '';
                } catch (error) {
                    return '';
                }
            } else if (customFields[field].type === 'time') {
                try {
                    return fieldValue ? moment(fieldValue).format('HH:mm') : '';
                } catch (error) {
                    return '';
                }
            } else {
                if (typeof fieldValue === 'object' && fieldValue !== null) {
                    return JSON.stringify(fieldValue);
                }
                return fieldValue?.toString() || '';
            }
        } else {
            return '';
        }
    });
}

export const validationListLeadTemplateAccess = (listLeadTemplateAccess: string, multiPipelines: SettingMultiPipelines[], fieldError: string[], intl: IntlShape, databasePipelineTitle: string) => {
    const allOption = [{ name: intl.formatMessage({ id: "FORM.LABEL.ALL" }, { title: intl.formatMessage({ id: "FORM.LABEL.TEMPLATE" }, { title: databasePipelineTitle }) }), value: 'all' }]
    let errorString: string[] = []
    const newMultiPipelines = multiPipelines.map(item => item.name);
    const newListLeadTemplateAccess = listLeadTemplateAccess.split(',').map((item: string) => item.trim())
    if (newListLeadTemplateAccess.length !== multiPipelines.length && !newListLeadTemplateAccess.includes(allOption[0].name)) {
        newListLeadTemplateAccess.forEach((leadAccessName) => {
            const newLeadAccessName = leadAccessName.trim()
            if (!newMultiPipelines.includes(newLeadAccessName)) {
                errorString.push(newLeadAccessName)
            }
        })
        if (errorString.length > 0) fieldError.push(`Database Pipeline tidak sesuai (${errorString})`)
    }
}

export const getIdListLeadTemplateAccess = (listNameLeadTemplateAccess: string, multiPipelines: SettingMultiPipelines[], intl: IntlShape, databasePipelineTitle: string) => {
    const allOption = [{ name: intl.formatMessage({ id: "FORM.LABEL.ALL" }, { title: intl.formatMessage({ id: "FORM.LABEL.TEMPLATE" }, { title: databasePipelineTitle }) }), value: 'all' }]
    const newListLeadTemplateAccess = listNameLeadTemplateAccess.split(',').map((item: string) => item.trim())
    if (newListLeadTemplateAccess.includes(allOption[0].name.trim())) {
        return multiPipelines.map(item => item.id)
    } else {
        return multiPipelines.filter((item) => {
            if (newListLeadTemplateAccess.includes(item.name)) return item
        }).map((item) => item.id)
    }
}